import React, {Component} from "react";
//import {browserHistory} from 'react-router';
import {injectIntl} from "react-intl";
import axios from "axios";
import {connect} from "react-redux";
import {Badge, Spin, Tag, Modal, message} from "antd";
import {subscribeWebsocket, unsubscribeWebsocket} from "../../../../../reducers/websocket";
import {LOGOUT} from "reducers/authenticationNew";
const platformName = "中科云翼互联智造服务云平台";

class PersonInfo extends Component {

  state = {
    loading: false,
    username: "",
    phone: "",
    avatar: "24dd932a187949579e35e8af7cfd352e.jpg", // user default logo
    status: "",
    code: "",
    companyName: "",
    roleNames: "",
    visible:false
  };

  constructor() {
    super();
    this.fetchData = this.fetchData.bind(this);
    this.fetchMessageCount = this.fetchMessageCount.bind(this);
  }

  componentDidMount() {
    this.fetchData(this.props.enterpriseId);
    this.fetchMessageCount(this.props.userId);
    // this.props.dispatch(subscribeWebsocket(
    //   `/message/${this.props.userId}`,
    //   count => {
    //     console.log("message received:", count);
    //     this.props.dispatch(updateMessageCount(count.body))
    //   }
    // ))
  }

  componentWillReceiveProps(nextProps) {
    if(this.props.enterpriseId!==nextProps.enterpriseId){
      this.fetchData(nextProps.enterpriseId);
    }
  }

  componentWillUnmount() {
  }
  handleOk = () => {
    let url="/api-user/updateRemove?userId="+this.props.userId;
    axios({
      method: "post",
      url: url,
      contentType: "application/json",
      withCredentials: true,
    }).then(
      response => response.data,
    ).then(
      response => {
        console.log(response);
        message.success("信息注销成功");
        this.props.handleLogoutClick();
      }
    ).catch(
      ex => {
      console.log(ex);
      message.error("信息注销失败");
    })
  };

   handleCancel = () => {
     this.setState({
       visible:false
     })
  };
  render() {
    const statusPart =   PersonInfo.renderStatus(this.state.code, this.language.bind(this),{...this.props});
    const bindRole = (this.state.companyName !== platformName ||
      (this.state.companyName === platformName && this.state.code === 3));
    let roles = null;
    if (!!this.state.roleNames)
      roles = this.state.roleNames.split(",").map(role => <Tag key={role}>{role}</Tag>);

    const welcomeLabel = this.language("user_service_person_info_welcome");
    const roleLabel = this.language("user_service_person_info_role_label");
    const companyLabel = this.language("user_service_person_info_company_label");
    const newCompanyLabel = this.language("user_service_person_info_create_company_label");
    const countDown = () => {
      const modal = Modal.warning({
        title: 'This is a notification message',
        content: `注销后将无法登录平台`,
        onOk:()=>{this.setState({visible:true})}
      }
      );
    };

    if (this.state.loading) {
      return (
        <Spin spinning={this.state.loading} size="large">
          <div style={{
            margin: "16px auto",
            // border: "1px solid rgba(0,0,0,.1)",
            borderRadius: "8px",
            background: "white",
            padding: "24px",
            display: "flex",
            justifyContent: "flex-start"
          }}/>
        </Spin>
      )
    } else {
      return (
        <div style={{
          margin: "16px auto",
          // border: "1px solid rgba(0,0,0,.1)",
          borderRadius: "8px",
          background: "white",
          padding: "24px",
          display: "flex",
          justifyContent: "flex-start"
        }}>
          <img style={{
            width: "104px",
            height: "104px",
            borderRadius: "100%",
            padding: "8px"
          }}
               alt=""
               src={`/api-imagefiles/browse?name=${this.state.avatar}`}
          />
          <div style={{padding: "8px"}}>
            <div style={{display: "flex", paddingLeft: "8px"}}>
              <div style={{
                fontSize: "18px",
                fontWeight: "800",
                marginRight: "8px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              }}>
                <div style={{paddingRight: 4}}>
                  {welcomeLabel}，{this.state.username}
                </div>
                {/*<Badge count={this.props.count} style={{ backgroundColor: "#f5222d", color: '#ffffff', borderRadius: "100%"}}/>*/}
              </div>
              {statusPart}
            </div>
            <div style={{padding: "8px"}}>
              {this.state.phone}
            </div>
            <div style={{paddingLeft: "8px", paddingBottom: "8px"}}>
              <span style={{paddingRight: "8px"}}>{roleLabel}</span>
              {
                roles
              }
              {/*
              TODO: 2018/03/26 temporarily hide
              {
                bindRole &&
                <a style={{fontSize: "12px", color: "rbga(0,0,0,.5)"}}>绑定新角色</a>
              }
              */}
            </div>
            <div style={{paddingLeft: "8px"}}>
              <span style={{paddingRight: "8px"}}>{companyLabel}</span>

              <Tag>{this.props.enterpriseId?this.state.companyName:""}</Tag>
              {
                this.state.code === "3" &&
                <a style={{fontSize: "12px", color: "rbga(0,0,0,.5)"}}
                   onClick={() => this.props.history.push("/console/create-enterprise-details")}>{newCompanyLabel}</a>
              }
            </div>
            <div style={{paddingLeft: "8px"}}>
              <span style={{paddingRight: "8px"}}>平台注销</span>
              {/*<Tag>{this.state.companyName}</Tag>*/}
              {
                <a style={{fontSize: "12px", color: "rbga(0,0,0,.5)"}}
                   onClick={countDown}>注销
                   {/*onClick={() =>this.setState({visible:true})}>注销*/}


                </a>
              }
            </div>
          </div>
          <Modal
            title="Title"
            visible={this.state.visible}
            onOk={this.handleOk}
            onCancel={this.handleCancel}
          >
            <p style={{color:'red'}}>是否确认注销</p>
          </Modal>
        </div>

      )
    }
  }

  static renderStatus(code, language,props) {
    switch (code) {
      case "1":
      case "2":
        return (
          <div style={{display: "flex", alignItems: "center"}}>
            <Tag>{language("user_service_person_info_verifying_status")}</Tag>
            <a style={{fontSize: "12px"}}>
              {language("user_service_person_info_verifying_status_instruction")}
            </a>
          </div>
        );
      case "3":
        return (
          <div style={{display: "flex", alignItems: "center"}}>
            <Tag>{language("user_service_person_info_verified_status")}</Tag>
            <a style={{fontSize: "12px"}}
               onClick={() => props.history.push("/console/edit-user-certify")}>
              {language("user_service_person_info_verified_status_instruction")}
            </a>
          </div>
        );
      case "4":
        return (
          <div style={{display: "flex", alignItems: "center"}}>
            <Tag>{language("user_service_person_info_verify_fail_status")}</Tag>
            <a style={{fontSize: "12px"}}
               onClick={() => props.history.push("/console/edit-user-certify")}>
              {language("user_service_person_info_verify_fail_status_instruction")}
            </a>
          </div>
        );
      default:
        return (
          <div style={{display: "flex", alignItems: "center"}}>
            <Tag>{language("user_service_person_info_verify_not_status")}</Tag>
            <a style={{fontSize: "12px"}}
               onClick={() => props.history.push("/console/create-user-certify")}>
              {language("user_service_person_info_verify_not_status_instruction")}
            </a>
          </div>
        );
    }
  }

  language(value) {
    return this.props.intl.formatMessage({id: value});
  }

  fetchData(enterpriseId) {
    this.setState({
      loading: true
    });
    axios({
      url: `/api-user/personInfoes?userId=${this.props.userId}&enterpriseId=${enterpriseId}`,
      method: "GET"
    }).then(
      response => {
        console.debug("PersonInfo: /personInfoes success", response.data);
        this.setState({
          loading: false,
          username: response.data.username,
          phone: response.data.phone,
          avatar: response.data.avatar || this.state.avatar,
          status: response.data.status,
          code: response.data.code,
          companyName: response.data.companyName,
          roleNames: response.data.roleNames
        })
      }
    ).catch(
      ex => {
        console.debug("PersonInfo: /personInfoes exception:", ex);
      }
    )
  }

  fetchMessageCount(userId) {
    axios({
      url: `/api-user/unreadCount?userId=${userId}`,
      method: "GET"
    }).then(
      response => {
        this.props.dispatch({
          type: "personInfo/UPDATE_MESSAGE_COUNT",
          data: response.data
        })
      }
    ).catch(
      ex => {
        console.error("PersonInfo: /unreadCount exception:", ex);
      }
    )
  }
}

export const mapStateToProps = (state) => ({
  username: state.authentication.username,
  enterpriseId: state.userData.enterprises[state.userData.currentEnterprise] ? state.userData.enterprises[state.userData.currentEnterprise].id : null,
  userId: state.authentication.userId,
  count: state.personInfo.count,
});

export const mapDispatchToProps = (dispatch) => ({
  dispatch,
  handleLogoutClick:()=>{
    dispatch({type: LOGOUT});
  },
});

export const personInfo = (state = {
  count: 0
}, action) => {
  switch(action.type) {
    case "personInfo/UPDATE_MESSAGE_COUNT":
      return {
        ...state,
        count: action.data
      };
    default:
      return state;
  }
};

export const updateMessageCount = (count) => {
  return {
    type: "personInfo/UPDATE_MESSAGE_COUNT",
    data: count
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(PersonInfo));

